<template>
  <div class="policy-info">
    <!-- 顶部导航栏 -->
    <AppHeader />
    
    <!-- Banner区域 -->
    <div class="banner">
      <div class="banner-background">
        <div class="city-skyline">
          <img src="@/images/index2.png" alt="株洲港口" class="skyline-image" />
        </div>
      </div>
    </div>

    <!-- 主要内容区域 -->
    <div class="main-content">
      <!-- 搜索栏 -->
      <div class="search-section">
        <div class="search-bar">
          <el-input
            v-model="searchKeyword"
            placeholder="请输入关键词搜索政策"
            class="search-input"
            @keyup.enter="searchPolicies"
          >
            <el-button slot="append" icon="el-icon-search" @click="searchPolicies"></el-button>
          </el-input>
        </div>
      </div>

      <!-- 政策列表 -->
      <div class="policy-list" v-loading="loading">
        <div class="policy-item" v-for="(policy, index) in filteredPolicies" :key="policy.id" :class="{ 'featured': index === 0 && currentPage === 1 }" @click="viewPolicyDetail(policy)" style="cursor: pointer;">
          <div class="policy-date">{{ policy.date }}</div>
          <div class="policy-content">
            <h3 class="policy-title">{{ policy.title }}</h3>
            <p class="policy-summary">{{ policy.summary }}</p>
            <div class="policy-tags">
              <span class="tag" v-for="tag in policy.tags" :key="tag">{{ tag }}</span>
            </div>
          </div>
        </div>
        
        <!-- 空状态 -->
        <div v-if="!loading && filteredPolicies.length === 0" class="empty-state">
          <p>暂无政策资讯数据</p>
        </div>
      </div>

      <!-- 分页 -->
      <div class="pagination-section">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="pageSize"
          layout="prev, pager, next"
          :total="totalPolicies"
        >
        </el-pagination>
      </div>
    </div>

    <!-- 底部 -->
    <AppFooter />
  </div>
</template>

<script>
import AppHeader from './AppHeader.vue'
import AppFooter from './AppFooter.vue'
import api from '@/utils/api'

export default {
  name: 'PolicyInfo',
  components: {
    AppHeader,
    AppFooter
  },
  data() {
    return {
      activeCategory: 'all',
      searchKeyword: '',
      currentPage: 1,
      pageSize: 10,
      loading: false,
      totalCount: 0,
      policies: []
    }
  },
  computed: {
    filteredPolicies() {
      return this.policies
    },
    totalPolicies() {
      return this.totalCount
    }
  },
  async mounted() {
    try {
      await api.checkAndGetToken()
      await this.loadPolicyList()
    } catch (error) {
      console.error('初始化失败:', error)
    }
  },
  methods: {
    // 获取政策列表
    async loadPolicyList() {
      try {
        this.loading = true
        
        
        const response = await api.getPolicyList(this.currentPage, this.pageSize)
        // console.log('政策资讯接口响应:', response)
        
        if (response && response.result && response.result.records) {
          // 转换数据格式
          this.policies = response.result.records.map(item => {
            const createTime = new Date(item.createTime)
            const date = `${createTime.getFullYear()}.${(createTime.getMonth() + 1).toString().padStart(2, '0')}.${createTime.getDate().toString().padStart(2, '0')}`
            
            return {
              id: item.id,
              date: date,
              title: item.policyIntroduce || '暂无标题',
              summary: item.policyIntroduce || '暂无摘要',
              tags: [item.policyType_dictText],
              category: 'policy',
              url: item.url || '',
              type: item.type || '',
              fileUpload: item.fileUpload || '',
            }
          })
          
          // 设置总数
          this.totalCount = response.result.total || 0
        }
      } catch (error) {
        console.error('获取政策资讯失败:', error)
        this.$message.error('获取政策资讯失败，请稍后重试')
      } finally {
        this.loading = false
      }
    },
    
    setActiveCategory(category) {
      this.activeCategory = category
      this.currentPage = 1
      this.loadPolicyList()
    },
    
    searchPolicies() {
      this.currentPage = 1
      this.loadPolicyList()
    },
    
    handleCurrentChange(page) {
      this.currentPage = page
      this.loadPolicyList()
    },
    
    viewPolicyDetail(policy) {
      if (policy.type == '1') {
        // 如果url是完整的http/https链接，直接跳转
        if (policy.url.startsWith('http://') || policy.url.startsWith('https://')) {
          window.open(policy.url, '_blank')
        } else {
          console.log('相对路径URL:', policy.url)
        }
      } else {
		window.open(policy.fileUpload, '_blank')
      }
    }
  }
}
</script>

<style scoped>
.policy-info {
  width: 100%;
  font-family: 'Microsoft YaHei', Arial, sans-serif;
  color: #333;
  background-color: white;
  padding-top: 0;
}

/* Banner区域样式 */
.banner {
  position: relative;
  height: 400px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.banner-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.city-skyline {
  left: 0;
  width: 100%;
  height: 100%;
}

.skyline-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* 主要内容区域 */
.main-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;
  background-color: #f5f5f5;
  min-height: calc(100vh - 300px);
}

/* 搜索栏 */
.search-section {
  margin-bottom: 30px;
  display: flex;
  justify-content: flex-end;
}

.search-bar {
  max-width: 400px;
  width: 100%;
}

.search-input {
  width: 100%;
}

.search-input .el-input__inner {
  border-radius: 20px;
  border: 1px solid #ddd;
  padding-left: 20px;
}

.search-input .el-input-group__append {
  border-radius: 0 20px 20px 0;
  border-left: none;
  background: #4A90E2;
}

.search-input .el-input-group__append .el-button {
  background: #4A90E2;
  border: none;
  color: white;
}

.search-input .el-input-group__append .el-button:hover {
  background: #357ABD;
}

/* 政策列表 */
.policy-list {
  margin-bottom: 30px;
}

.policy-item {
  background: white;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border-left: 4px solid #4A90E2;
  transition: all 0.3s ease;
}

.policy-item:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
  transform: translateY(-2px);
}

/* 特色政策项样式 */
.policy-item.featured {
  background: linear-gradient(135deg, #4A90E2 0%, #357ABD 100%);
  color: white;
  padding: 30px;
  border-radius: 8px;
  border-left: none;
  margin-bottom: 20px;
  box-shadow: 0 4px 20px rgba(74, 144, 226, 0.3);
}

.policy-item.featured .policy-date {
  background: rgba(255, 255, 255, 0.2);
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.3);
}

.policy-item.featured .policy-title {
  color: white;
  font-size: 20px;
  font-weight: 700;
}

.policy-item.featured .policy-title:hover {
  color: #ecf0f1;
}

.policy-item.featured .policy-summary {
  color: rgba(255, 255, 255, 0.9);
  font-size: 15px;
}

.policy-item.featured .tag {
  background: rgba(255, 255, 255, 0.2);
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.3);
}

.policy-date {
  display: inline-block;
  font-size: 12px;
  color: white;
  font-weight: 500;
  background: #4A90E2;
  padding: 4px 12px;
  border-radius: 4px;
  margin-bottom: 12px;
}

.policy-content {
  width: 100%;
}

.policy-title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin: 0 0 10px 0;
  cursor: pointer;
  transition: color 0.3s ease;
  line-height: 1.4;
}

.policy-title:hover {
  color: #4A90E2;
}

.policy-summary {
  font-size: 14px;
  color: #666;
  line-height: 1.6;
  margin: 0 0 15px 0;
}

.policy-tags {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.tag {
  background: #e8f4fd;
  color: #4A90E2;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 12px;
  border: 1px solid #d1e9ff;
}

/* 分页 */
.pagination-section {
  display: flex;
  justify-content: center;
  margin-top: 30px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .main-content {
    padding: 20px 10px;
  }
  
  .search-section {
    justify-content: center;
  }
  
  .search-bar {
    max-width: 100%;
  }
  
  .policy-item {
    padding: 15px;
  }
  
  .policy-item.featured {
    padding: 20px;
  }
}

/* 空状态样式 */
.empty-state {
  text-align: center;
  padding: 60px 20px;
  color: #999;
  font-size: 16px;
}

.empty-state p {
  margin: 0;
}
</style>